<template>
  <div class="menusCheck mainBox">
    <div class="menusCheckLeft wow animate__animated animate__slideInLeft">
      <div class="menusCheckItem" v-for="(item, index) in softwareList" :key="index"
        :class="[active == index && 'menusCheckActive']" @click="changeActive(index)">
        <div class="menusCheckName">
          {{ item.name }}
        </div>
        <div class="menusCheckSubTitle">
          {{ item.subTitle }}
        </div>
      </div>
    </div>
    <div class="menusCheckRight wow animate__animated animate__slideInRight">
      <div class="rightBox">
        <transition name="zoom-fade" mode="out-in">
          <OssImg class="rightImg" :key="active" :src="softwareList[active].img" alt="" />
        </transition>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";

const softwareList = ref([
  {
    name: "智慧实验室综合软件平台",
    subTitle: "全场景覆盖、全流程管控、全要素协同",
    img: "images/pdtSoft1.png",
  },
  {
    name: "化学品全生命周期系统",
    subTitle: "全流程监督，管制类专项管控",
    img: "images/pdtSoft8.png",
  },
  {
    name: "安全准入考试系统",
    subTitle: "规范人员准入流程、提升安全意识",
    img: "images/pdtSoft7.png",
  },
  {
    name: "安全巡检系统",
    subTitle: "规范巡检流程、强化隐患排查、降低安全风险",
    img: "@/assets/images/UIV5/system.png",
  },
  {
    name: "资源共享系统",
    subTitle: "资源整合 - 智能调配 - 共享服务 - 绩效评估",
    img: "@/assets/images/UIV5/system.png",
  },
]);

const active = ref(0);

const changeActive = (index) => {
  active.value = index;
};
</script>

<style lang="scss" scoped>
.menusCheck {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  .menusCheckLeft {
    width: 35%;
    box-sizing: border-box;

    .menusCheckItem {
      cursor: pointer;
      transition: all 0.3s;

      .menusCheckName {
        border-bottom: 0.0625rem solid #e5e6eb;
        padding: 1rem 0;
        font-weight: bold;
        font-size: 1.5rem;
        color: #424242;
      }

      .menusCheckSubTitle {
        margin-top: .6rem;
        color: #888888;
        font-weight: 500;
        font-size: 1rem;
        width: 100%;
        height: 0;
        overflow: hidden;
        transition: all 0.5s;
      }

      &:last-of-type .menusCheckName {
        border-bottom: 0;
      }

      &:hover {
        .menusCheckName {
          color: #32A89E;
        }
      }
    }

    .menusCheckActive {
      .menusCheckName {
        color: #32A89E;
        border-bottom: 0.0625rem solid #32A89E;
      }

      .menusCheckSubTitle {
        height: auto;
      }
    }
  }

  .menusCheckRight {
    flex: 1;
    height: 30rem;

    .rightBox {
      width: 100%;
      height: 100%;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;

      .rightImg {
        width: 100%;
        height: 100%;
        transition: all 0.5s;
      }
    }
  }
}

// /* 组合动画效果 - 淡入淡出 + 缩放 */
.zoom-fade-enter-active,
.zoom-fade-leave-active {
  transition: all 0.5s cubic-bezier(0.22, 1, 0.36, 1);
}

.zoom-fade-enter-from {
  opacity: 0.3;
}

.zoom-fade-enter-to {
  opacity: 1;
}

.zoom-fade-leave-from {
  opacity: 1;
}

.zoom-fade-leave-to {
  opacity: 0.4;
}

// @media(max-width: 768px) {
//   .menusCheck {
//     flex-direction: column;
//   }
// }
</style>
